/**
 * Shader data grouping.
 */
export enum ShaderDataGroup {
  /** Scene group. */
  Scene,
  /** Camera group. */
  Camera,
  /** Renderer group. */
  Renderer,
  /** Material group. */
  Material,
  /** Render element group. */
  RenderElement
}
